import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var FaucetSVG = function FaucetSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M42,25v4a4,4,0,0,1-4,4H26a2,2,0,0,0-2,2v6a1,1,0,0,1-2,0V39a1,1,0,0,0-2,0v2a1,1,0,0,1-2,0V39a1,1,0,0,0-2,0v2a1,1,0,0,1-2,0V39a1,1,0,0,0-2,0v2a1,1,0,0,1-2,0V27a6,6,0,0,1,6-6H38A4,4,0,0,1,42,25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__accent-color-fill",
    x: "16.143",
    y: "5.571",
    width: "15.429",
    height: "2.571"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M34.786,15.857H31.507a3.214,3.214,0,0,0-3.15-2.571h-.643V10.714h3.857a2.579,2.579,0,0,0,2.572-2.571V5.571A2.579,2.579,0,0,0,31.571,3H16.143a2.579,2.579,0,0,0-2.572,2.571V8.143a2.579,2.579,0,0,0,2.572,2.571H20v2.572h-.643a3.214,3.214,0,0,0-3.15,2.571H13.571a9.01,9.01,0,0,0-9,9v4.089a3.851,3.851,0,0,0,1.286,7.483H17.429a3.851,3.851,0,0,0,1.285-7.483v-.232H34.786A3.215,3.215,0,0,0,38,25.5V19.071A3.215,3.215,0,0,0,34.786,15.857ZM16.143,8.143V5.571H31.571V8.143Zm9,2.571v2.572H22.571V10.714ZM5.857,33.857a1.286,1.286,0,1,1,0-2.571H17.429a1.286,1.286,0,0,1,0,2.571m18-7.714h-18a1.289,1.289,0,0,0-1.286,1.286v1.285h-9V24.857a6.431,6.431,0,0,1,6.428-6.428h5.143V17.143A1.29,1.29,0,0,1,20,15.857h8.357A.637.637,0,0,1,29,16.5v1.929h6.429Z"
  }));
};
FaucetSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
FaucetSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Faucet")
};
export default withDetailedIcon(FaucetSVG);